export const FAQ_CATEGORIES = [
  { id: 'all', label: 'Все вопросы', description: 'Полный список ответов' },
  { id: 'messages', label: 'Сообщения', description: 'Чаты и доставка' },
  { id: 'account', label: 'Аккаунт', description: 'Вход и профиль' },
  { id: 'files', label: 'Файлы', description: 'Вложения и медиа' },
  { id: 'search', label: 'Поиск', description: 'Контакты и идентификаторы' }
];

const RAW_FAQ_QUESTIONS = [
  {
    id: 'create-chat',
    category: 'messages',
    title: 'Как создать чат?',
    summary: 'Новый диалог создается через поиск пользователя.',
    answer: 'Откройте сообщения, найдите пользователя по имени, номеру или идентификатору и откройте диалог.',
    steps: [
      'Перейдите в раздел «Сообщения».',
      'Откройте поиск или создание нового диалога.',
      'Введите имя, номер телефона или идентификатор.',
      'Выберите пользователя.'
    ],
    tips: ['Для группы сначала создайте групповой чат.', 'Если контакт не находится, проверьте регистрацию в GovChat.'],
    keywords: ['создать чат', 'новый диалог', 'группа']
  },
  {
    id: 'send-message',
    category: 'messages',
    title: 'Как отправить сообщение?',
    summary: 'Откройте чат, введите текст и нажмите кнопку отправки.',
    answer: 'Сообщение отправляется из активного диалога и появляется в истории сразу после успешной отправки.',
    steps: [
      'Откройте нужный чат.',
      'Введите текст в поле снизу.',
      'Нажмите кнопку отправки.'
    ],
    tips: ['При слабом интернете отправка может занять больше времени.'],
    keywords: ['отправить сообщение', 'написать']
  },
  {
    id: 'message-not-sent',
    category: 'messages',
    title: 'Почему не отправляется сообщение?',
    summary: 'Обычно проблема в сети, сессии или лимитах чата поддержки.',
    answer: 'Проверьте интернет, обновите приложение и убедитесь, что сообщение отправляется в обычный чат, а не в ограниченный системный канал.',
    steps: [
      'Проверьте соединение с интернетом.',
      'Обновите страницу или откройте приложение заново.',
      'Повторите отправку через несколько секунд.',
      'Если проблема сохраняется, напишите в поддержку.'
    ],
    tips: ['В чате поддержки действуют ограничения: только текст и лимит на частоту сообщений.'],
    keywords: ['не отправляется', 'ошибка сообщения', 'лимит']
  },
  {
    id: 'send-file',
    category: 'files',
    title: 'Как отправить файл?',
    summary: 'Используйте кнопку вложения рядом с полем ввода.',
    answer: 'Выберите файл, дождитесь загрузки и отправьте его в текущий чат.',
    steps: [
      'Откройте диалог.',
      'Нажмите кнопку вложения.',
      'Выберите документ, фото или видео.',
      'Подтвердите отправку.'
    ],
    tips: ['Не закрывайте чат, пока большой файл загружается.'],
    keywords: ['файл', 'вложение', 'документ']
  },
  {
    id: 'restore-access',
    category: 'account',
    title: 'Как восстановить доступ?',
    summary: 'Повторно войдите в аккаунт и проверьте правильность номера телефона.',
    answer: 'Если вход не работает, перезапустите приложение, заново введите данные и при необходимости обратитесь в поддержку.',
    steps: [
      'Обновите страницу или перезапустите приложение.',
      'Введите номер телефона и пароль без лишних пробелов.',
      'Проверьте, что используете номер, на который зарегистрирован аккаунт.',
      'Если вход недоступен, напишите в поддержку.'
    ],
    tips: ['Не отправляйте пароль в чат поддержки.'],
    keywords: ['восстановить доступ', 'не могу войти', 'пароль']
  },
  {
    id: 'user-not-found',
    category: 'search',
    title: 'Почему пользователь не найден?',
    summary: 'Скорее всего, введены неточные данные или пользователь еще не зарегистрирован.',
    answer: 'Проверьте правильность имени, номера телефона или идентификатора. Если данных мало, поиск может не показать нужного человека.',
    steps: [
      'Проверьте номер телефона и имя.',
      'Попробуйте искать по другому признаку.',
      'Уточните у пользователя, на какой номер он зарегистрирован.',
      'Если поиск пустой, обратитесь в поддержку.'
    ],
    tips: ['Надежнее искать по полному номеру телефона.'],
    keywords: ['пользователь не найден', 'поиск', 'контакт']
  },
  {
    id: 'find-user',
    category: 'search',
    title: 'Как быстрее найти пользователя?',
    summary: 'Лучше всего искать по полному номеру телефона или точному идентификатору.',
    answer: 'Короткие имена часто дают несколько совпадений, поэтому используйте максимально точные данные.',
    steps: [
      'Откройте раздел поиска.',
      'Введите полный номер телефона или точный идентификатор.',
      'Выберите нужного пользователя из результатов.'
    ],
    tips: ['Если результатов несколько, уточните номер телефона.'],
    keywords: ['как найти пользователя', 'userId', 'идентификатор']
  },
  {
    id: 'support-contact',
    category: 'account',
    title: 'Куда писать, если ответ не найден?',
    summary: 'Откройте системный чат поддержки прямо из FAQ.',
    answer: 'Если готового ответа не хватило, используйте кнопку перехода в чат поддержки GovChat.',
    steps: [
      'Нажмите «Открыть чат поддержки».',
      'Кратко опишите, что случилось.',
      'Добавьте текст ошибки, если он есть.'
    ],
    tips: ['Полезно указать устройство, браузер и время возникновения ошибки.'],
    keywords: ['поддержка', 'задать вопрос', 'чат поддержки']
  }
];

export const FAQ_QUESTIONS = RAW_FAQ_QUESTIONS.map((item) => ({
  ...item,
  searchIndex: [
    item.title,
    item.summary,
    item.answer,
    ...(item.steps || []),
    ...(item.tips || []),
    ...(item.keywords || [])
  ].join(' ').toLowerCase()
}));

export const FAQ_SUPPORT_HINTS = [
  'Что именно вы пытались сделать',
  'В каком разделе возникла проблема',
  'Текст ошибки или скриншот'
];
